import { render, staticRenderFns } from "./oldList.vue?vue&type=template&id=0852e757&scoped=true"
import script from "./oldList.vue?vue&type=script&lang=js"
export * from "./oldList.vue?vue&type=script&lang=js"
import style0 from "./oldList.vue?vue&type=style&index=0&id=0852e757&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852e757",
  null
  
)

export default component.exports